module.exports = __webpack_public_path__ + "static/finley-book-chinese-331b00c9f235ccd6abdc06f8ee8440b3.jpg";